import { useNewCabinets, useMarkCabinetsAsVisited } from '@/hooks/useNewCabinets';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Building2 } from 'lucide-react';

export const NewCabinetsDialog = () => {
  const { data: newCabinets } = useNewCabinets();
  const markAsVisited = useMarkCabinetsAsVisited();
  
  const hasNewCabinets = (newCabinets?.length || 0) > 0;
  
  const handleAccess = (_cabinetId: string) => {
    markAsVisited.mutate();
    // Recharger la page pour appliquer le nouveau cabinet
    window.location.reload();
  };
  
  const handleDismiss = () => {
    markAsVisited.mutate();
  };
  
  if (!hasNewCabinets) return null;
  
  return (
    <Dialog open={hasNewCabinets} onOpenChange={(open) => !open && handleDismiss()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-4 flex items-center justify-center w-16 h-16 bg-grey-100 rounded-full">
            <Building2 className="h-8 w-8 text-grey-600" />
          </div>
          <DialogTitle className="text-center text-base font-medium">
            {newCabinets?.length === 1 
              ? 'Nouveau cabinet disponible !'
              : `${newCabinets?.length} nouveaux cabinets disponibles !`
            }
          </DialogTitle>
          <DialogDescription className="text-center px-4">
            {newCabinets?.length === 1
              ? "Vous avez été ajouté(e) à un nouveau cabinet"
              : "Vous avez été ajouté(e) à plusieurs cabinets"
            }
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-3 py-4 max-h-[300px] overflow-y-auto">
          {newCabinets?.map((cabinet) => (
            <div 
              key={cabinet.id}
              className="p-4 border border-grey-200 rounded-lg hover:bg-grey-50 hover:border-grey-200 cursor-pointer transition-all"
              onClick={() => handleAccess(cabinet.id)}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <p className="font-medium text-grey-900">{cabinet.cabinet_name}</p>
                  </div>
                  <p className="text-sm text-grey-600">
                    Ajouté le {new Date(cabinet.created_at).toLocaleDateString('fr-FR')}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <DialogFooter className="flex gap-2 sm:gap-2">
          <Button 
            variant="outline" 
            onClick={handleDismiss} 
            className="flex-1"
          >
            Plus tard
          </Button>
          {newCabinets && newCabinets.length === 1 && (
            <Button 
              onClick={() => { const first = newCabinets?.[0]; if (first) handleAccess(first.id); }}
              className="flex-1 bg-charcoal hover:bg-charcoal-dark"
            >
              Accéder au cabinet
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default NewCabinetsDialog;
